$(function() {
  if($('#extraComments').length) {
    $('.pic-select img').on('error', function() {
      $(this).parent().remove();
    });

    $('.pic-select .pic').on('click', function() {
      $('.pic-select .pic').removeClass('active');
      $(this).addClass('active');
      $('#eCode').val($(this).data('code'));
    });

    $('#comFrm').on('submit', function() {
      var link = $('#eLink').val();
      if (link.length == 0) {
        alert('Please select a post!');
        return false;
      }

      var comments = $('#eComments').val();
      if (comments.length == 0) {
        alert('Please enter some comments!');
        return false;
      }

      $(this).find('button').prop('disabled', true);
      return true;
    });
  }
});
